module.exports = __webpack_public_path__ + "static/media/voxwizard-2.89ea5f1f.jpg";